import React, { useRef } from "react";

import { useTranslation } from "react-i18next";
import CustomModal from "@app/components/2_widgets/CustomModal";
import { useToast } from '@app/components/3_modules/ToastContainer';
import { apiCall } from '@app/utils/apiCall';
import { useAuth } from '@app/contexts/AuthContext';
import { Trash2 } from "lucide-react";

export default function CustomerDelete({customer, reload}) {
    const refModal = useRef();
    const toast = useToast();  
    const { t } = useTranslation();
    const auth = useAuth();

    function confirmDeletion() {
        apiCall ({
            method: "delete",
            path: `/api/v1/customers/${customer.id}`,
            auth: auth,
            onSuccess: (response) => {
                toast.addToast("Suppression", t("customer.delete.success"));
                reload();
            }
        });
    }

    function deleteCustomer(event) {
        event.stopPropagation();
        event.preventDefault();        
        
        refModal.current.displayModal(
            t("customer.delete.modal_title_warning"),
            t("customer.delete.modal_desc_warning", {company_name: customer.company_name}),
            t("word.confirm"),
            t("word.cancel"),
            confirmDeletion
        )
    }

    return (
        <>
            <div onClick={deleteCustomer} className="default-icon red ms-2"><Trash2 /></div>
            <CustomModal ref={refModal} />
        </>        
    )
}